import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const WindIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.9165 3.8055V21.2648H2.8335C2.511 21.2648 2.25 21.5415 2.25 21.882C2.25 22.2233 2.511 22.5 2.8335 22.5H12.1665C12.489 22.5 12.75 22.2233 12.75 21.882C12.75 21.5415 12.489 21.2648 12.1665 21.2648H8.0835V10.1849L12.1899 12.663C12.3076 12.7345 12.4465 12.7632 12.5829 12.744L21.9579 11.424C22.2684 11.3805 22.5002 11.1015 22.5002 10.77V6.48C22.5002 6.14925 22.2677 5.8695 21.9579 5.826L12.5829 4.506C12.4355 4.48563 12.2857 4.52092 12.1629 4.605L8.0835 7.37355V3.80475C8.43225 3.59175 8.667 3.19275 8.667 2.73525C8.667 2.05275 8.14425 1.5 7.5 1.5C6.855 1.5 6.333 2.05275 6.333 2.73525C6.333 3.19275 6.56775 3.59175 6.9165 3.8055ZM8.2021 8.79603C8.16268 8.79091 8.12296 8.78967 8.0835 8.79229V8.78782C8.13382 8.79111 8.18449 8.78811 8.2343 8.77879C8.31597 8.76352 8.39362 8.73159 8.46241 8.685L12.6384 5.8455L13.5 5.96667V11.2913L12.6384 11.4135L8.43541 8.877C8.36401 8.83432 8.28459 8.80676 8.2021 8.79603ZM15 11.0787L17.2655 10.7574C17.2553 10.7169 17.25 10.675 17.25 10.632V6.618C17.25 6.57643 17.255 6.53581 17.2645 6.49654L15 6.1778V11.0787ZM18.75 6.70563V10.547L21.2499 10.1925V7.0575L18.75 6.70563Z'
                fill='currentColor'
            />
        </>
    ),
})

WindIcon.displayName = 'WindIcon'
